<template>
  <div class="delivery_order">
    <!-- main frame -->
    <v-container grid-list-md fluid>
      <!-- part 1 DO detail  -->
      <v-layout wrap row>
        <v-flex xs12>
          <v-card class="elevation-10" color="blue-grey lighten-5">
            <!-- <v-card-title>
              <v-icon large left>zoom_out_map</v-icon>
              <span class="title font-weight-heavy">Create DO</span>
            </v-card-title>-->

            <v-card-text>
              <v-layout wrap row justify-space-around>
                <!-- DO create date -->
                <v-flex xs2>
                  <v-menu
                    lazy
                    :close-on-content-click="true"
                    v-model="date_box"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Date"
                      v-model="date"
                      persistent-hint
                      readonly
                    ></v-text-field>

                    <v-date-picker
                      v-model="date"
                      @input="date_box = false"
                      no-title
                      actions
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <!-- customer selection  -->
                <v-flex xs2>
                  <v-autocomplete
                    v-model="customer"
                    :items="customerList"
                    item-text="name"
                    item-value="id"
                    label="Customer"
                    ref="customer"
                    persistent-hint
                    return-object
                    small-chips
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs2>
                  <v-textarea outline auto-grow height="25px" v-model="remark" label="Remark/Reason"></v-textarea>
                </v-flex>
                <v-flex xs4></v-flex>

                <!-- button create do  -->
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <!-- part 2 DO item -->
      <v-layout wrap row>
        <v-flex xs12>
          <v-card class="elevation-10">
            <v-card-text>
              <!--  insert item into DO -->
              <v-layout wrap row>
                <!--  Select Product -->
                <v-flex xs2>
                  <v-autocomplete
                    v-model="product"
                    :items="productList"
                    item-text="product_code_name"
                    item-value="id"
                    v-on:keyup.enter="checkingProudctType(),VegeNext()"
                    v-on:change="checkingProudctType(),vege_change_clear_field()"
                    label="Vege"
                    ref="product"
                    chips
                    return-object
                  >
                    <template slot="item" slot-scope="{ item }">
                      {{ item.product_code_name }} &nbsp; &nbsp;
                      <v-avatar size="38">
                        <img :src="(baseUrl+'/product/vege_img/'+item.picture)" />
                      </v-avatar>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <!--  Select Grade -->
                <v-flex xs1 v-if="setting_grade == true">
                  <v-autocomplete
                    v-model="grade"
                    :items="gradeList"
                    item-text="name"
                    item-value="name"
                    v-on:keyup.enter="GradeNext()"
                    label="Grade"
                    ref="grade"
                    chips
                  ></v-autocomplete>
                </v-flex>

                <!--  Select Location -->
                <v-flex xs1 v-if="setting_location == true">
                  <v-autocomplete
                    v-model="location"
                    :items="locationList"
                    item-text="name"
                    item-value="name"
                    v-on:keyup.enter="LocationNext()"
                    label="Location"
                    ref="location"
                    chips
                  ></v-autocomplete>
                </v-flex>

                <!--  Type Weight -->
                <v-flex xs2>
                  <v-text-field
                    v-if="product_type_need_weight==true"
                    v-model="weight"
                    v-on:keyup.enter="WeightNext()"
                    v-on:change="weight = Math.max(Math.min(weight, 9999999), 0.1)"
                    type="number"
                    ref="weight"
                    label="weight(kg)"
                    box
                  ></v-text-field>
                </v-flex>

                <!--  Type Quantity -->
                <v-flex xs2>
                  <v-text-field
                    v-model="quantity"
                    v-on:keyup.enter="QuantityNext()"
                    v-on:change="quantity = Math.max(Math.min(Math.round(quantity), 9999999), 1)"
                    ref="qty"
                    type="number"
                    label="Qty"
                    box
                  ></v-text-field>
                </v-flex>

                <!-- Type Price -->
                <v-flex xs1 >
                  <v-text-field
                    v-model="price"
                    v-on:keyup.enter="PriceNext();"
                    v-on:change="price = Math.max(Math.min(price, 9999999), 0)"
                    ref="price"
                    type="number"
                    label="Price"
                    box
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-btn color="primary" @click="additemToDO()">
                    <v-icon>subdirectory_arrow_left</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>

              <!-- do item local table -->
              <v-layout>
                <v-flex xs12>
                  <v-data-table
                    :headers="headers"
                    :items="local_do_stock"
                    disable-initial-sort
                    :rows-per-page-items="[100, 150, 200, 250]"
                    class="elevation-1"
                    height="60px"
                  >
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td>
                          <v-avatar size="38">
                            <img :src="(baseUrl+'/product/vege_img/'+props.item.product_image)" />
                          </v-avatar>
                        </td>
                        <td class="text-xs-right">{{ props.item.product_name }}</td>
                        <td class="text-xs-right">{{ props.item.grade }}</td>
                        <td class="text-xs-right">{{ props.item.location }}</td>
                        <td class="text-xs-right">{{ props.item.weight }}</td>
                        <td class="text-xs-right">{{ props.item.quantity }}</td>
                        <td class="text-xs-right">{{ props.item.price }}</td>

                        <td class="justify-end layout px-5">
                          <v-icon
                            medium
                            color="error"
                            @click="deleteDOitem(props.item)"
                          >delete_forever</v-icon>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-row>
                <v-btn
                  color="primary"
                  :loading="saving"
                  :disabled="saving"
                  @click.native="save_do"
                >Save</v-btn>
              </v-row>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Snackbar when axios method responsed  (jump out at bottom) -->
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="1500">
      {{response_detail}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>

    <!-- Snackbar when axios method error catched  (jump out at top) -->
    <v-snackbar v-model="snackbar_no_connection" :top="true" :timeout="6000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar_connection = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import moment from "moment";
// import { throttle } from "lodash";
//import VWidget from "@/components/user_widget/vwidget";
//import delivery_order_list from "@/components/large_component/delivery_order_list";

export default {
  components: {
    //VWidget,
  },
  data() {
    return {
      //fixed
      baseUrl: baseUrl,

      //array

      customerList: [],
      productList: [],
      farmerList_WithSelectedProduct: [],
      gradeList: [],
      locationList: [],
      local_do_stock: [],
      headers: [
        { text: "Image", value: "product_image" },
        { text: "Veg", align: "right", value: "product_name" },
        { text: "Grade", align: "right", value: "grade" },
        { text: "Location", align: "right", value: "location" },
        { text: "Weight/Box", align: "right", value: "weight" },
        { text: "Qty", align: "right", value: "quantity" },
        { text: "RM", align: "right", value: "price" },
        { text: "Actions", align: "right", value: "action", sortable: false }
      ],

      //main value
      date: moment().format("YYYY-MM-DD"),
      customer: "",
      delivery_driver: "",
      product: "",
      weight: "",
      quantity: "",
      price: "",
      grade: "",
      location: "",
      basket_quantity: "",

      new_grade: "",
      new_location: "",

      remark: "",

      //logic control
      product_type_need_weight: true,
      setting_grade: true,
      setting_location: true,
      setting_price: true,
      limitDay: "",
      saving: false,

      //others
      response_detail: "",
      vege_adding_loading_value: "",

      // dialog snackbar date_box
      setting_dialog: false,
      date_box: false,
      vege_adding_loading_dialog: false,
      snackbar_response: false,
      snackbar_no_connection: false
    };
  },
  created() {
    this.getCustomer();
    this.getProduct();
    this.getGrade();
    this.getLocation();
  },
  mounted() {
    this.intervalFetch();
  },
  computed: {},

  methods: {
    getCustomer() {
      const params = new URLSearchParams();
      params.append("get_customer", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_customer.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.customerList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Customer List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getGrade() {
      const params = new URLSearchParams();
      params.append("get_grade", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.gradeList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Grade List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getLocation() {
      const params = new URLSearchParams();
      params.append("get_location", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.locationList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Location List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    save_do() {
      this.saving = true;

      //checking whether data filled
      if (this.date && this.customer.id && this.local_do_stock.length > 0) {
        const params = new URLSearchParams();
        params.append("create_cn", "create_cn");
        params.append("date", this.date);
        params.append("customer_id", this.customer.id);
        params.append("remark", this.remark);
        params.append("cn_item_array", JSON.stringify(this.local_do_stock));

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/stock/customer_cn.php",
          data: params
        })
          .then(response => {
            console.log(response);
            if (response.data.error == false) {
              //set response to selected data

              this.snackbar_response = true;
              this.response_detail = "New CN created";
              this.after_save_clear_field();
               this.$emit("update", "someValue");

              this.saving = false;
            } else if (response.data.error == true) {
              this.saving = false;

              this.snackbar_response = true;
              this.response_detail = response.data.message;
            }
          })
          .catch(error => {
            console.log(error);
            this.snackbar_connection = true;
            this.saving = false;
          });
      } else {
        this.snackbar_response = true;
        this.saving = false;

        this.response_detail = "Please fill in the detail & vege";
      }
    },
    getProduct() {
      const params = new URLSearchParams();
      params.append("getAllProduct", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/product/product.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.productList = response.data.data;
            this.clearallfield();
          } else if (response.data.error == true) {
            console.log("Product List Problem" + response.data.message);
            this.clearallfield();
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },

    additemToDO() {
      //checking whether data filled
      console.log(this.weight);
      if (this.product.id && this.weight && this.quantity) {
        if (this.grade == "") {
          this.grade = "unknown";
        }
        if (this.location == "") {
          this.location = "unknown";
        }
        if (this.price == "") {
          this.price = "0";
        }

        for (var i = 0; i < this.local_do_stock.length; i++) {
          /*
          checking input
          */

          if (
            this.local_do_stock[i].weight == this.weight &&
            this.local_do_stock[i].grade == this.grade &&
            this.local_do_stock[i].location == this.location &&
            this.local_do_stock[i].product_id == this.product.id
          ) {
            this.local_do_stock[i].quantity += this.quantity;
            this.product = "";
            this.weight = "";
            this.quantity = "";
            this.price = "";
            this.grade = "";
            this.location = "";
            //  this.$refs.product.focus();

            return;
          }
        }

        this.local_do_stock.push({
          product_image: this.product.picture,
          product_name: this.product.name,
          product_id: this.product.id,
          grade: this.grade,
          location: this.location,
          weight: this.weight,
          quantity: this.quantity,
          price: parseFloat(this.price).toFixed(2),
          type: this.product.type
        });

        this.product = "";
        this.weight = "";
        this.quantity = "";
        this.price = "";
        this.grade = "";
        this.location = "";

        this.$refs.product.focus();
      } else {
        this.snackbar_response = true;
        this.response_detail = "Please fill in the detail";
      }
    },
    deleteDOitem(item) {
      const index = this.local_do_stock.indexOf(item);
      this.local_do_stock.splice(index, 1);
    },
    checkingProudctType() {
      if (this.product.type == "box" || this.product.type == "bag" || this.product.type == "pkt"|| this.product.type == "pcs" ) {
        this.product_type_need_weight = false;
        this.weight = "1";
      } else {
        this.product_type_need_weight = true;
        this.weight = "";
      }
    },
    VegeNext_item() {
      if (this.setting_grade == true) {
        this.$refs.grade.activateMenu();
        this.$refs.grade.focus();
      } else if (this.setting_location == true) {
        this.$refs.location.focus();
        this.$refs.location.activateMenu();
      } else if (this.product.type == "box" || this.product.type == "bag" || this.product.type == "pkt"|| this.product.type == "pcs" ) {
        this.$refs.qty.focus();
      } else {
        this.$refs.weight.focus();
      }
    },
    VegeNext() {
      var self = this;
      setTimeout(function() {
        self.VegeNext_item();
      }, 200);
    },

    GradeNext() {
      if (this.setting_location == true) {
        console.log("hahaaa");
        this.$refs.location.focus();
        this.$refs.location.activateMenu();
      } else if (this.product.type == "box" || this.product.type == "bag" || this.product.type == "pkt"|| this.product.type == "pcs" ) {
        this.$refs.qty.focus();
      } else {
        this.$refs.weight.focus();
      }
    },
    LocationNext() {
      if (this.product.type == "box" || this.product.type == "bag" || this.product.type == "pkt"|| this.product.type == "pcs" ) {
        console.log("hahaaaaaa");
        this.$refs.qty.focus();
      } else {
        this.$refs.weight.focus();
      }
    },
    WeightNext() {
      this.$refs.qty.focus();
    },
    QuantityNext() {
      if (this.setting_price == true) {
        this.$refs.price.focus();
      } else {
        this.additemToDO();
      }
    },
    PriceNext() {
      this.additemToDO();
    },

    vege_change_clear_field() {
      this.location = "";
      this.weight = "";
      this.quantity = "";
      this.price = "";
      this.grade = "";
    },
    after_save_clear_field() {
      this.local_do_stock = [];
      this.customer = "";
      this.weight = "";
      this.quantity = "";
      this.price = "";
      this.grade = "";
      this.location = "";
      this.product = "";
      this.remark = "";
    },
    intervalFetch: function() {
      setInterval(() => {
        this.limitDay = localStorage.stocked_day_limit;
        this.setting_grade = localStorage.setting_grade;
        this.setting_location = localStorage.setting_location;
        this.setting_price = localStorage.setting_price;
        if (this.setting_grade == "true") {
          this.setting_grade = true;
        } else {
          this.setting_grade = false;
        }
        if (this.setting_location == "true") {
          this.setting_location = true;
        } else {
          this.setting_location = false;
        }

        if (this.setting_price == "true") {
          this.setting_price = true;
        } else {
          this.setting_price = false;
        }
      }, 500);
    }
  }
};
</script>

